import styled from 'styled-components'
import CatalogContents from './components/CatalogContents'

function PageCatalogMobile() {
  return (
    <MainContainer>
      <CatalogContents isMobile={true} />
    </MainContainer>
  )
}

export default PageCatalogMobile

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 66px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 60.7px;
  background: #f7f7f7;
`
